/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2021 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
import { setOrbitControls, setParent } from './_misc';
export { updateEvents, getParent, destroy, setSize } from './_misc';
export const initEvents = ({ canvas, orbitControls }) => {
    setOrbitControls(orbitControls);
    setParent(canvas);
};
//# sourceMappingURL=flat.js.map